export const locationsData = [
    {
        "name":"PRIVADA 0c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 160.1255 680.479)",
    },
    {
        "name":"PRIVADA 1c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 310.1255 940.479)",
    },
    {
        "name":"PRIVADA 2c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 510.1255 1340.479)",
    },
    {
        "name":"PRIVADA 18c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 690.1255 1640.479)",
    },
    {
        "name":"PRIVADA 19c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 450.1255 2000.479)",
    },
    {
        "name":"PRIVADA 20c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 450.1255 2450.479)",
    },
    {
        "name":"PRIVADA 3c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 1310.1255 1180.479)",
    },
    {
        "name":"PRIVADA 4c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 1350.1255 1580.479)",
    },
    {
        "name":"PRIVADA 5c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 2140.1255 1520.479)",
    },
    {
        "name":"PRIVADA 6c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 2000.1255 1920.479)",
    },
    {
        "name":"PRIVADA 7c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 1850.1255 2300.479)",
    },
    {
        "name":"PRIVADA 8c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 1845.1255 2700.479)",
    },
    {
        "name":"PRIVADA 9c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 2600.1270 2170.479)",
    },
    {
        "name":"PRIVADA 10c",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDAS",
        "transform":"matrix(1 0 0 1 2500.1270 2570.479)",
    },
    {
        "name":"PRIVADA 11tx",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDOS",
        "transform":"matrix(1 0 0 1 2500.1270 2970.479)",
    },
    {
        "name":"PRIVADA 12t",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDOS",
        "transform":"matrix(1 0 0 1 2500.1270 3270.479)",
    },
    {
        "name":"PRIVADA 13tx",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDOS",
        "transform":"matrix(1 0 0 1 2270.1270 3900.479)",
    },
    {
        "name":"DEPAS",
        "coords":"",
        "shape":"poly",
        "color":"000000",
        "text":"VENDIDOS",
        "transform":"matrix(1 0 0 1 1150.1255 2500.479)",
    },
    {//CORDS terrenos
        "name":"PRIVADA 12cs",
        "coords":"2958.86 3214.02 2187.84 3105.59 2176.66 3180.46 2119.86 3172.71 2110.4 3262.21 2260.99 3284.58 2255.82 3321.58 2656.82 3381.82 2622.4 3624.48 2688.66 3713.98 2880.56 3741.51 2958.86 3214.02",
        "shape":"poly",
        "color":"000000",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 11cs",
        "coords":"2958 3214.02 3014.8 2805.28 2276.48 2701.15 2267.01 2776.88 2256.68 3038.47 2247.22 3112.48 2958 3214.02",
        "shape":"poly",
        "color":"000000",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 13cs",
        "coords":"2540.65 4340.43 2626.7 4264.7 2592.28 4190.7 2583.68 4196.73 2514.84 4120.14 2555.28 4120.14 2540.65 3849.94 2534.63 3839.61 2252.38 3515.2 2191.28 3571.13 2137.93 3515.2 2094.91 3553.92 2145.68 3609.86 2127.61 3627.93 2176.66 3787.12 2193.01 3843.91 2277.34 3936.85 2220.54 3988.48 2540.65 4340.43",
        "shape":"poly",
        "color":"000000",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 15cs",
        "coords":"2653.38 5022.82 2653.38 5009.05 2419.32 4750.9 2383.18 4782.73 2129.33 4501.35 1883.22 4725.94 1944.32 4797.36 1889.24 4846.41 2193.87 5187.18 2230.01 5155.34 2544.96 5505 2572.49 5417.79 2611.22 5293.88 2647.36 5182.87 2653.38 5022.82",
        "shape":"poly",
        "color":"000000",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 14cs",
        "coords":"2554.42 4900.62 2617.24 4843.83 2661.13 4892.02 2665.43 4798.22 2722.22 4468.65 2578.52 4308.59 2540.65 4343.01 2304.87 4081.42 2206.77 4169.19 2254.96 4229.42 2106.95 4363.66 2126.75 4387.76 2069.95 4437.67 2383.18 4783.59 2418.46 4750.9 2554.42 4900.62",
        "shape":"poly",
        "color":"000000",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 22cs",
        "coords":"708.62 3554.78 843.72 3248.44 869.54 3178.74 288.69 2967.91 288.69 3052.24 263.74 3312.98 253.41 3390.42 708.62 3554.78",
        "shape":"poly",
        "color":"000000",
        "text":"",
        "transform":"",
    },
]